import { render, staticRenderFns } from "./TeleportV2.vue?vue&type=template&id=811d2746&scoped=true&"
import script from "./TeleportV2.vue?vue&type=script&lang=js&"
export * from "./TeleportV2.vue?vue&type=script&lang=js&"
import style0 from "./TeleportV2.vue?vue&type=style&index=0&id=811d2746&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811d2746",
  null
  
)

export default component.exports